/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc4Inputs */

const en_fc_tut_sc4 = /** @type {(inputs: Fc_Tut_Sc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract`)
};

/**
* | output |
* | --- |
* | "Extract" |
*
* @param {Fc_Tut_Sc4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc4 = /** @type {((inputs?: Fc_Tut_Sc4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc4(inputs)
});
export { fc_tut_sc4 as "fc.tut.sc4" }